// extracted by mini-css-extract-plugin
export default {"popup":"o9qXePyNI9DhZPCnuTKB","modalContent":"VbBtmHrvxCMw4hZCBkJX","positionUnset":"gFmfyGkoSvya7_l7Z0zv","changeStyleButton":"I_hF5KdzeGnjhImMS0pP"};